import { render, staticRenderFns } from "./StocksTab.vue?vue&type=template&id=3f176005&scoped=true&"
import script from "./StocksTab.vue?vue&type=script&lang=js&"
export * from "./StocksTab.vue?vue&type=script&lang=js&"
import style0 from "./StocksTab.vue?vue&type=style&index=0&id=3f176005&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f176005",
  null
  
)

export default component.exports
import {QCard,QBtnToggle,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QBtnToggle,QBtn})
